export default "__VITE_ASSET__DtmDDpCk__"